/**
 * Translates the Essential Preorder app's "back in stock" popup, which the
 * app injects into the DOM at runtime with its own English strings - outside
 * Liquid/theme templates, so Translate & Adapt can't reach it, and the app
 * only offers in-app translations on a paid plan. This patches the visible
 * text after the fact using the app's own data-essential-preorder-element
 * attributes (a stable API the app itself exposes), reading the target
 * strings from window.essentialPreorderTranslations (set by Liquid via the
 * theme's normal locale files, so it's translated for whichever locale the
 * page is rendered in - not hardcoded to one language).
 */
(function () {
  var rawTranslations = window.essentialPreorderTranslations;
  if (!rawTranslations) return;

  var decoder = document.createElement('textarea');
  function decodeEntities(value) {
    if (typeof value !== 'string' || value.indexOf('&') === -1) return value;
    decoder.innerHTML = value;
    return decoder.value;
  }

  var translations = {};
  Object.keys(rawTranslations).forEach(function (key) {
    translations[key] = decodeEntities(rawTranslations[key]);
  });

  var WRAPPER_SELECTOR = '[data-essential-preorder-element="back-in-stock-pop-up-wrapper"]';

  var TEXT_ELEMENTS = [
    ['back-in-stock-pop-up-title', 'title'],
    ['back-in-stock-pop-up-description', 'description'],
    ['back-in-stock-pop-up-newsletter-label', 'newsletterLabel'],
    ['back-in-stock-pop-up-button-text', 'buttonText'],
    ['back-in-stock-pop-up-disclaimer', 'disclaimer'],
    ['back-in-stock-pop-up-input-error-text', 'emailError'],
  ];

  function applyTranslations() {
    var wrapper = document.querySelector(WRAPPER_SELECTOR);
    if (!wrapper) return;

    TEXT_ELEMENTS.forEach(function (pair) {
      var elementAttr = pair[0];
      var translationKey = pair[1];
      var text = translations[translationKey];
      if (!text) return;

      var el = wrapper.querySelector('[data-essential-preorder-element="' + elementAttr + '"]');
      if (el && el.textContent !== text) {
        el.textContent = text;
      }
    });

    var input = wrapper.querySelector('[data-essential-preorder-element="back-in-stock-pop-up-input"]');
    if (input && translations.emailPlaceholder && input.getAttribute('placeholder') !== translations.emailPlaceholder) {
      input.setAttribute('placeholder', translations.emailPlaceholder);
    }
  }

  var observer = new MutationObserver(applyTranslations);
  observer.observe(document.body, { childList: true, subtree: true, characterData: true });

  applyTranslations();
})();
